import React, { Component } from 'react';
import WetSlider from './WetSlider.js';
import EffectParameterSlider from './EffectParameterSlider.js';

class TremoloEffect extends Component {
    constructor(props) {
        super(props);
        this.state = {
            tremoloEffect: props.tremoloEffect,
        };
    }

    shouldComponentUpdate(nextProps, nextState) {
        this.state.tremoloEffect = nextProps.tremoloEffect;
        return true;
    }

    handleDepthChange(depth) {
        this.state.tremoloEffect.setDepth(depth);
        this.setState(this.state);
    }

    handleRateChange(rate) {
        this.state.tremoloEffect.setRate(rate);
        this.setState(this.state);
    }

    handleWetChange(wet) {
        this.state.tremoloEffect.setWet(wet);
        this.setState(this.state);
    }

    isEnabled() {
        return this.props.automation !== undefined ? true :
            this.state.tremoloEffect.isEnabled();
    }

    render() {
        var rate = Math.round(this.state.tremoloEffect.getRate()*10)/10;
        var depth = this.state.tremoloEffect.getDepth();
        var wet = this.state.tremoloEffect.getWet();
        let className = this.props.automation !== undefined ?
            'enabled effect tall-effect effect-automation' :
            this.state.tremoloEffect.isEnabled() ? 'tall-effect effect enabled' :
            'disabled effect';
        return (
            <div>
              {!this.isEnabled() ? '' :
                <div>
                  <EffectParameterSlider
                        effectNumber={this.props.effectNumber}
                        automation={this.props.automation}
                        name='Rate'
                        selectedParameter={this.props.selectedParameter}
                        displayFunction={(rate) => Math.round(this.state.tremoloEffect.getRate()*10)/10}
                        lfoEnabled={true}
                        sequencerEngine={this.props.sequencerEngine}
                        onParameterChanged={this.props.onParameterChanged}
                        parameter={this.state.tremoloEffect.rateParameter}
                        isParameter={true}
                        step={0.1}
                        max={16}
                        min={0}
                        />
                   <EffectParameterSlider
                        effectNumber={this.props.effectNumber}
                        automation={this.props.automation}
                        name='Depth'
                        selectedParameter={this.props.selectedParameter}
                        parameter={this.state.tremoloEffect.depthParameter}
                        onParameterChanged={this.props.onParameterChanged}
                        lfoEnabled={true}
                        sequencerEngine={this.props.sequencerEngine}
                        isParameter={true}
                        step={0.1}
                        max={1}
                        min={0}
                        />
                     <EffectParameterSlider
                        effectNumber={this.props.effectNumber}
                        automation={this.props.automation}
                        name='Spread'
                        selectedParameter={this.props.selectedParameter}
                        parameter={this.state.tremoloEffect.spreadParameter}
                        onParameterChanged={this.props.onParameterChanged}
                        lfoEnabled={true}
                        sequencerEngine={this.props.sequencerEngine}
                        isParameter={true}
                        step={1}
                        max={360}
                        min={0}
                        />
                       <WetSlider
                             effectNumber={this.props.effectNumber}
                             sequencerEngine={this.props.sequencerEngine}
                             automation={this.props.automation}
                             onParameterChanged={this.props.onParameterChanged}
                             effect={this.state.tremoloEffect}/>
                </div>} 
            </div>
        );
   }
}

export default TremoloEffect;
